import { __ } from '@wordpress/i18n';
import { addFilter } from '@wordpress/hooks';
import { InspectorControls } from '@wordpress/block-editor';
import {
    PanelBody,
    PanelRow,
    SelectControl,
    __experimentalToolsPanel as ToolsPanel,
	__experimentalToolsPanelItem as ToolsPanelItem,
	__experimentalGrid as Grid,
	ToggleControl,
} from '@wordpress/components';

export const withMioExhibitionDateFilter = ( BlockEdit ) => ( props ) => {
    
    const isExhibitionList = (props) => {
        const attrs = props?.attributes
        return attrs.namespace === 'museuio-companion/exhibition-list' && attrs.query.postType === 'mio_exhibition'
    }

    const dateFilterControl = (props) => {
        const { attributes, setAttributes } = props;
        const query = attributes.query;

        return (
            <PanelBody
                title={__('Date filter', 'museuio-companion')}
                initialOpen={true}
            >
                <PanelRow>
                    <SelectControl
                        label={__('Exhibitions to show', 'museuio-companion')}
                        labelPosition="top"
                        value={query.mioExhibitionDateFilter}
                        options={[
                            { label: __('All', 'museuio-companion'), value: 'all' },
                            { label: __('On Show', 'museuio-companion'), value: 'on-show' },
                            { label: __('Upcoming', 'museuio-companion'), value: 'upcoming' },
                            { label: __('Past', 'museuio-companion'), value: 'past' },
                        ]}
                        onChange={(val) => { query.mioExhibitionDateFilter = val; setAttributes({ query: query }) }}
                    ></SelectControl>
                </PanelRow>
                {'on-show' === query.mioExhibitionDateFilter ? <PanelRow>
                    <Grid columns={ 1 }>
                        <ToggleControl
                            label={ __('Include future', 'museuio-companion') }
                            labelPosition="left"
                            checked={ query.mioOnShowIncludeFuture }
                            onChange={ ( val ) => { query.mioOnShowIncludeFuture = !query.mioOnShowIncludeFuture; /*setAttributes({ query: query })*/ }}
                            ></ToggleControl>
                    </Grid>		
                </PanelRow> : '' }
            </PanelBody>
        )
    }

    return isExhibitionList( props ) ? (
        <>
            <BlockEdit { ...props } />
            <InspectorControls>
                { dateFilterControl(props) }
            </InspectorControls>
        </>
    ) : (
        <BlockEdit { ...props } />
    );
};

addFilter( 'editor.BlockEdit', 'core/query', withMioExhibitionDateFilter );